export default function ProcessingSpeedsSection() {
  const tiers = [
    {
      label: "Most Urgent",
      days: "3 Business Days",
      description: "For travel within the next week. Hand-courier delivery to agency with reserved submission slot. Overnight FedEx return.",
      icon: "ri-flashlight-fill",
      highlighted: false,
      accent: "border-l-red-500",
      badge: null,
    },
    {
      label: "Expedited",
      days: "4 Business Days",
      description: "For travel within about 1–2 weeks. Priority submission with expedited agency processing.",
      icon: "ri-rocket-2-fill",
      highlighted: true,
      accent: "border-l-[#F6C344]",
      badge: "Most Popular",
    },
    {
      label: "Standard Fast",
      days: "7 Business Days",
      description: "For travel within about 2 weeks. Reliable expedited processing without top-tier rush pricing.",
      icon: "ri-speed-up-fill",
      highlighted: false,
      accent: "border-l-blue-400",
      badge: null,
    },
    {
      label: "Value Expedited",
      days: "9 Business Days",
      description: "For travel 2–3 weeks out. Faster than standard government timelines at a lower price point.",
      icon: "ri-timer-fill",
      highlighted: false,
      accent: "border-l-teal-500",
      badge: null,
    },
    {
      label: "Smart Saver",
      days: "3–5 Weeks",
      description: "For travelers with time to spare. Most affordable option. Expert review and courier handling still included.",
      icon: "ri-leaf-fill",
      highlighted: false,
      accent: "border-l-green-500",
      badge: null,
    },
  ];

  return (
    <section id="processing-speeds" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Processing Tiers</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your <span className="text-[#F6C344]">Expedited Processing Speed</span>
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            Every passport situation is different. Whether you have a week or three weeks, we have a processing tier that fits your travel date. All tiers include expert document review, courier submission, and overnight FedEx return delivery.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {tiers.map((tier, i) => (
            <div
              key={i}
              className={`relative bg-white rounded-xl border ${tier.accent} border-l-4 border-t border-r border-b border-gray-200 p-6 transition-shadow hover:shadow-md flex flex-col ${
                tier.highlighted ? "ring-2 ring-[#F6C344] ring-offset-2" : ""
              }`}
            >
              {tier.badge && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#F6C344] text-[#1A365D] text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                  {tier.badge}
                </div>
              )}
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${tier.highlighted ? "bg-[#F6C344]/20" : "bg-[#1A365D]/10"} mb-4`}>
                <i className={`${tier.icon} ${tier.highlighted ? "text-[#C79315]" : "text-[#1A365D]"} text-lg`}></i>
              </div>
              <h3 className="font-serif text-lg font-bold text-[#1A365D] mb-1">{tier.label}</h3>
              <p className="text-[#F6C344] font-bold text-xl mb-3">{tier.days}</p>
              <p className="text-gray-500 text-sm leading-relaxed mb-5 flex-1">{tier.description}</p>
              <a
                href="https://fastpassportcenter.com/checkout/"
                className={`inline-flex items-center justify-center gap-2 font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap ${
                  tier.highlighted
                    ? "bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D]"
                    : "bg-[#1A365D] hover:bg-[#0F2240] text-white"
                }`}
              >
                View Pricing & Start <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-gray-400 text-xs">
            All processing speeds are business days and begin when we receive your complete documents. Government fees are separate and required regardless of service tier.
          </p>
        </div>
      </div>
    </section>
  );
}